import React from 'react';
import PropTypes from 'prop-types';

const CardAgenda = ({
  dataHoraInicio, dataHoraTermino, descricao, local, secretaria, status, tipo, titulo, video,
}) => {
  const getCor = (st) => {
    if (st === 'Participe') { return 'gray'; }
    if (st === 'Realizado') { return 'green'; }
    if (st === 'Adiado') { return '#b1b100'; }
    if (st === 'Cancelado') { return 'red'; }
    return 'gray';
  };
  return (
    <div style={{
      border: '1px solid rgb(207 207 207 / 75%)', padding: '20px', width: '100%', marginBottom: '30px', background: 'rgb(203 203 203 / 7%)',
    }}
    >
      <div style={{
        gap: '31px', display: 'flex', alignItems: 'center',
      }}
      >
        {(status)
        && (
        <span style={{
          background: getCor(status), padding: '10px', border: '2px solid black', color: 'white', fontWeight: 'bolder', minWidth: '150px', textAlign: 'center',
        }}
        >
          {status}
        </span>
        )}
        {(dataHoraInicio) && (
        <span>
          <span style={{ fontWeight: 'bold' }}>Início: </span>
          {' '}
          {dataHoraInicio}
        </span>
        )}
        {(dataHoraTermino) && (
        <span>
          <span style={{ fontWeight: 'bold' }}>Término: </span>
          {dataHoraTermino}
        </span>
        )}
      </div>
      {(secretaria) && (
      <p style={{ fontWeight: 'bold' }}>
        {secretaria}
      </p>
      )}
      {(descricao) && (
      <>
        <span style={{ fontWeight: 'bolder' }}>Descrição:</span>
        {' '}
        <p style={{ display: 'inline-block', marginBottom: '-10px' }} dangerouslySetInnerHTML={{ __html: descricao }} />
      </>
      )}
      {(local)
      && (
      <p>
        <span style={{ fontWeight: 'bold' }}>Local: </span>
        {' '}
        {local}
      </p>
      )}
      {(tipo) && (
      <span>
        <span style={{ fontWeight: 'bold' }}>Tipo: </span>
        {' '}
        {tipo}
      </span>
      )}
      {(titulo) && (
      <p>
        <span style={{ fontWeight: 'bold' }}>Local: </span>
        {' '}
        {titulo}
      </p>
      )}
      {(video) && (
      <p>
        <span style={{ fontWeight: 'bold' }}>Vídeo: </span>
        {' '}
        {video}
      </p>
      )}
    </div>
  );
};

CardAgenda.propTypes = {
  dataHoraInicio: PropTypes.string,
  dataHoraTermino: PropTypes.string,
  descricao: PropTypes.string,
  local: PropTypes.string,
  secretaria: PropTypes.string,
  status: PropTypes.string,
  tipo: PropTypes.string,
  titulo: PropTypes.string,
  video: PropTypes.string,
};

CardAgenda.defaultProps = {
  dataHoraInicio: '',
  dataHoraTermino: '',
  descricao: '',
  local: '',
  secretaria: '',
  status: '',
  tipo: '',
  titulo: '',
  video: '',
};

export default CardAgenda;
